// extracted by mini-css-extract-plugin
module.exports = {"nav":"Main-styles-module--nav--2hw03","main":"Main-styles-module--main--2QNBf"};